import { FC } from 'react';
import { Button } from 'antd';
import { TbExternalLink, TbLinkMinus, TbWorld } from 'react-icons/tb';

import PlatformAlert from '../PlatformAlert';

interface PublicSharingBannerProps {
    disabled?: boolean;
    publicUrl: string;
    resourceLabel: string;
    onTurnOffSharing: () => void | Promise<void>;
}

const PublicSharingBanner: FC<PublicSharingBannerProps> = ({
    disabled = false,
    publicUrl,
    resourceLabel,
    onTurnOffSharing,
}) => {
    const lowerResourceLabel = resourceLabel.toLowerCase();

    return (
        <PlatformAlert
            banner
            showIcon
            type='info'
            icon={<TbWorld size='0.875rem' />}
            message={`This ${lowerResourceLabel} is public.`}
            action={
                <>
                    <Button
                        size='small'
                        style={{ marginRight: '0.5rem' }}
                        icon={
                            <TbExternalLink
                                size='1rem'
                                style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }}
                            />
                        }
                        onClick={() => {
                            window.open(publicUrl, '_blank', 'noopener,noreferrer');
                        }}
                    >
                        View Public {resourceLabel}
                    </Button>
                    <Button
                        size='small'
                        type='dashed'
                        icon={
                            <TbLinkMinus size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />
                        }
                        onClick={onTurnOffSharing}
                        disabled={disabled}
                    >
                        Turn Off Sharing
                    </Button>
                </>
            }
            style={{
                minHeight: '3rem',
                borderRadius: 0,
                position: 'sticky',
                top: 0,
                zIndex: 2,
            }}
        />
    );
};

export default PublicSharingBanner;
